module.exports = __webpack_public_path__ + "static/media/logoDigihapi.bb22897f.png";